import { Button } from "@tracify/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@tracify/ui/dialog";

type Props = {
  open: boolean;
  onClose: () => void;
};

const GOOGLE_ADS_CONVERSIONS_URL = "https://ads.google.com/aw/conversions";

const GooglePostbackEnabledDialog = ({ open, onClose }: Props) => {
  return (
    <Dialog
      open={open}
      onOpenChange={(open) => {
        if (!open) {
          onClose();
        }
      }}
    >
      <DialogContent className="max-w-md w-[calc(100vw-2rem)] sm:w-full">
        <DialogHeader>
          <DialogTitle>Google conversion postback enabled</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-muted-foreground">
          Conversion postback is enabled for Google Ads. Tracify will create a
          dedicated conversion action and will automatically send conversion
          data to it. This conversion action will take a few hours to create and
          will be called{" "}
          <a
            href={GOOGLE_ADS_CONVERSIONS_URL}
            target="_blank"
            rel="noreferrer"
            className="underline"
          >
            Tracify Conversions
          </a>
        </p>
        <DialogFooter className="flex justify-end mt-4">
          <Button onClick={onClose} className="w-full sm:w-auto">
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default GooglePostbackEnabledDialog;
